import { ChevronLeft, ChevronRight } from "lucide-react";
import { formatDay } from "@/lib/organizer";

const button = "inline-flex items-center gap-1 min-h-[40px] px-3 py-2 rounded-full border border-slate-200 bg-white text-sm font-semibold text-slate-700 hover:border-teal-300";

export const WeekNav = ({ week, overdueCount, onChange }) => {
  if (!week) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 p-3 rounded-2xl bg-sky-50 border border-sky-100" data-testid="organizer-week-nav">
      <button type="button" data-testid="organizer-week-prev" onClick={() => onChange(week.prev)} className={button}><ChevronLeft size={14} /> Previous week</button>
      <div className="flex-1 text-center text-sm font-semibold text-slate-800" data-testid="organizer-week-label">
        {formatDay(week.start)} – {formatDay(week.end)}
        {week.is_current && <span className="ml-2 chip">This week</span>}
      </div>
      <button type="button" data-testid="organizer-week-next" onClick={() => onChange(week.next)} className={button}>Next week <ChevronRight size={14} /></button>
      {!week.is_current && <button type="button" data-testid="organizer-week-today" onClick={() => onChange("")} className="text-xs font-semibold text-teal-800 underline underline-offset-2">Back to current week</button>}
      {overdueCount > 0 && <div className="w-full text-xs text-rose-700 font-semibold" data-testid="organizer-week-overdue-note">Includes {overdueCount} overdue unfinished item{overdueCount === 1 ? "" : "s"} from any week.</div>}
    </div>
  );
};
